import { CONSULTATION_COMPANY_MODAL_ACTION_TYPE } from "../actions-type";

const initialState = {
  consultationCompanyModalData: {},
  consultationCompanyOpenModal: false,
  consultationCompanyModalLoading: false,
};

export const consultationCompanyModalReducer = (
  state = initialState,
  action,
) => {
  switch (action.type) {
    case CONSULTATION_COMPANY_MODAL_ACTION_TYPE.GET_CONSULTATION_COMPANY_MODAL:
      return {
        ...state,
        consultationCompanyModalData: action.payload.data,
        consultationCompanyOpenModal: action.payload.openModal,
      };
    case CONSULTATION_COMPANY_MODAL_ACTION_TYPE.CONSULTATION_COMPANY_OPEN_MODAL:
      return {
        ...state,
        consultationCompanyOpenModal: action.payload,
      };
    case CONSULTATION_COMPANY_MODAL_ACTION_TYPE.CONSULTATION_COMPANY_MODAL_LOADING:
      return {
        ...state,
        consultationCompanyModalLoading: action.payload,
      };
    default:
      return state;
  }
};
